import React from 'react';

export function calculate(answers) {
  const items = [];
  const panelCount = Number(answers.panelCount) || 0;
  const grantYear = answers.grantYear;

  // Updated grant breakdown table per CSV documentation
  const grantTable = {
    "2024": [800, 800, 250, 250],
    "2025": [700, 700, 200, 200],
    "2026": [600, 600, 150, 150]
  };

  // Always display the system size field (in bold)
  let systemSize = 0;
  let systemSizeDisplay = "--";
  if (panelCount > 0) {
    systemSize = (panelCount * 440) / 1000;
    systemSizeDisplay = `${systemSize.toFixed(2)} kWp`;
  }

  // If no panels selected, return with message but keep the system size field visible
  if (panelCount <= 0) {
    items.push("No solar panels selected.");
    return {
      status: "No Grant",
      items,
      message: "Select at least one solar panel to see a grant calculation.",
      color: "grey"
    };
  }

  const yearGrants = grantTable[grantYear];
  if (!yearGrants) {
    return {
      status: "Error",
      items,
      message: `Grant year ${grantYear} is not supported.`,
      color: "red"
    };
  }

  let totalGrant = 0;
  
  // The grant calculation maxes out at 4kWp
  if (systemSize >= 4) {
    totalGrant = yearGrants.reduce((sum, value) => sum + value, 0);
    items.push("✔️ Maximum grant value achieved.");
  } else {
    items.push(" ");
    // For a system smaller than 4kWp, calculate using whole cells and a portion of the next cell
    const whole = Math.floor(systemSize);
    const fraction = systemSize - whole;
    const fullCellsSum = yearGrants.slice(0, whole).reduce((sum, value) => sum + value, 0);
    let partial = 0;
    if (whole < yearGrants.length) {
      partial = yearGrants[whole] * fraction;
    }
    totalGrant = fullCellsSum + partial;
    // Always show breakdown details for systems below 4kWp
  }

  const status = `€${totalGrant.toFixed(2)}`;
  const message = (
    <span>
      Based on a system size of <strong>{systemSize.toFixed(2)} kWp</strong> for grant year {grantYear}.
    </span>
  );
  const color = totalGrant > 0 ? "green" : "red";
  const title = "Grant Amount";

  return { status, items, message, color, title };
}